import React, { useEffect } from 'react'
import '../css/ConnectionResult.css'

const ConnectionResult = ({
  isSuccess,
  onRetry,
  onDone,
  flowType = 'tm', // 'tm' | 'guest'
  message,
  actionLabel, //  NEW: allows blocked/timeout screens to show OK or Back to Guest Form
  hidePrimaryAction = false,
  autoActionDelayMs = null,
}) => {
  useEffect(() => {
    if (!isSuccess || !autoActionDelayMs || !onDone) {
      return undefined
    }

    const timer = window.setTimeout(() => {
      onDone()
    }, autoActionDelayMs)

    return () => window.clearTimeout(timer)
  }, [autoActionDelayMs, isSuccess, onDone])

  const handlePrimaryAction = () => {
    if (isSuccess) {
      onDone?.()
      return
    }

    onRetry?.(flowType)
  }

  const primaryLabel = isSuccess
    ? actionLabel || 'Done'
    : actionLabel || `Retry ${flowType === 'tm' ? 'Team Member' : 'Guest'} Flow`

  return (
    <div className="connection-result">
      <div className="connection-result__container">
        <div className="connection-result__logo">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="45" fill="#cc0000" />
            <circle cx="50" cy="50" r="28" fill="white" />
            <circle cx="50" cy="50" r="14" fill="#cc0000" />
          </svg>
        </div>

        <div
          className={`connection-result__icon ${isSuccess ? 'success' : 'error'}`}
        >
          {isSuccess ? '✓' : '✗'}
        </div>

        <h1 className="connection-result__title">
          {isSuccess ? "You're connected" : 'You are not connected'}
        </h1>

        <p className="connection-result__subtitle">
          {isSuccess
            ? message || 'You can now access Target Guest Wi-Fi.'
            : message || 'Connection failed. Please try again.'}
        </p>

        {!hidePrimaryAction && (
          <div className="connection-result__actions">
            <button
              className="connection-result__btn primary"
              onClick={handlePrimaryAction}
            >
              {primaryLabel}
            </button>
          </div>
        )}

        {isSuccess && autoActionDelayMs && hidePrimaryAction && (
          <p className="connection-result__redirect-note">
            {/* Redirecting in {Math.ceil(autoActionDelayMs / 1000)} seconds... */}
          </p>
        )}
      </div>
    </div>
  )
}

export default ConnectionResult
